import { cn } from '@/lib/utils';
import { SearchInput } from '@/components/shared/search-input';
import type { ReadingListStatus } from '@/types';

// Barra de filtros de "Lecturas Asignadas": pestañas de estado + búsqueda por código o
// título (mismo patrón visual que Mis Documentos / Capacitaciones). Mobile-first: en
// móvil se apilan y las pestañas hacen scroll horizontal si no caben.
const STATUS_TABS: { label: string; value: ReadingListStatus | undefined }[] = [
  { label: 'Todas', value: undefined },
  { label: 'Pendientes', value: 'pending' },
  { label: 'Vencidas', value: 'overdue' },
  { label: 'Confirmadas', value: 'completed' },
];

type Props = {
  status: ReadingListStatus | undefined;
  searchInput: string;
  onStatusChange: (value: ReadingListStatus | undefined) => void;
  onSearchChange: (value: string) => void;
};

export function ReadingsFilters({ status, searchInput, onStatusChange, onSearchChange }: Props) {
  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
      <div
        role="group"
        aria-label="Filtrar por estado"
        className="flex gap-1 overflow-x-auto rounded-lg border border-border bg-muted/50 p-1"
      >
        {STATUS_TABS.map((tab) => {
          const active = status === tab.value;
          return (
            <button
              key={tab.label}
              type="button"
              aria-pressed={active}
              onClick={() => onStatusChange(tab.value)}
              className={cn(
                'min-h-[44px] shrink-0 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
                active
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground',
              )}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      <SearchInput
        className="flex-1"
        value={searchInput}
        onChange={onSearchChange}
        placeholder="Buscar por código o título..."
      />
    </div>
  );
}
